<template>
  <button v-bind="$props" class="cta" v-on="$listeners">
    <slot />
  </button>
</template>

<script>
export default {
  name: "Cta",
};
</script>

<style lang="scss" scoped>
.cta {
  @include red-shadow;
  transition: padding 0.3s;
  font-size: 0.9rem;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  display: inline-block;
  padding: $size-space-n2 $size-space-2;
  margin-left: auto;
  margin-right: auto;
  background-color: #f40009;
  border-radius: 48px;
  text-align: center;
  text-decoration: none;
  border: none;
  min-height: 40px;
  width: 100%;
  cursor: pointer;
  line-height: 1.25;
  overflow-wrap: break-word;
}
</style>
